import React from 'react';

export default function GTLogo({ size = 42, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Outer square with chamfered corners */}
      <path
        d="M6 2H36L40 6V36L36 40H6L2 36V6L6 2Z"
        fill="#050608"
        stroke="#c8a96e"
        strokeWidth="1.2"
      />
      {/* Inner gold border line */}
      <path
        d="M8 4.5H34L37.5 8V34L34 37.5H8L4.5 34V8L8 4.5Z"
        fill="none"
        stroke="#c8a96e"
        strokeWidth="0.4"
        strokeOpacity="0.4"
      />
      {/* Letter G */}
      <text
        x="7"
        y="27"
        fontFamily="'Cormorant Garamond', Georgia, serif"
        fontSize="18"
        fontWeight="600"
        fontStyle="italic"
        fill="#c8a96e"
        letterSpacing="-0.5"
      >G</text>
      {/* Letter T */}
      <text
        x="22"
        y="27"
        fontFamily="'Cormorant Garamond', Georgia, serif"
        fontSize="18"
        fontWeight="600"
        fontStyle="italic"
        fill="#f5f2ee"
        letterSpacing="-0.5"
      >T</text>
      {/* Bottom gold line accent */}
      <line x1="10" y1="32" x2="32" y2="32" stroke="#c8a96e" strokeWidth="0.6" strokeOpacity="0.5" />
    </svg>
  );
}
